<template>
    <div class="container">
      <success-page :code="0" :boletoUrl="null" :type="'newVehicle'" :novoCartao="true" :salesOrder="order"></success-page>
    </div>
</template>
<script>
import successPage from '../common/adhesion/success.vue'
export default {
    data() {
      return {
        valorDebitado: undefined,
        cpm: undefined
      }
    },
    computed: {
        order() {
            return {contractPaymentMethod: this.cpm};
        }
    },
    mounted() {
        this.cpm = sessionStorage.getItem("validar-cartao");
        sessionStorage.removeItem("validar-cartao");
        
        if(!this.cpm) {
            this.$router.push({name: 'plans'});
        }
        this.cpm = JSON.parse(this.cpm);

    },
    components: {successPage}
}
</script>



// WEBPACK FOOTER //
// validar-cartao.vue?e40cdd4a